import { Suspense } from 'react';

const LazyRoute = ({ children }) => {
  return <Suspense>{children}</Suspense>;
};

export default LazyRoute;
